import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  TemplateRef,
} from '@angular/core';
import { FlatNode } from '@ui';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'ui-tree-node-option',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, NzIconModule],
  template: `
    @if (template()) {
      <ng-container
        *ngTemplateOutlet="
          template();
          context: { $implicit: node()?.context || null }
        "
      ></ng-container>
    } @else {
      <div class="flex justify-start items-center gap-x-1">
        @if (node().icon?.length) {
          <nz-icon [nzType]="node().icon || ''" />
        }
        {{ node()!.name }}
      </div>
    }
  `,
})
export class TreeNodeOptionComponent {
  node = input.required<FlatNode>();
  template = computed(() =>
    this.isTemplate(this.node().template)
      ? (this.node().template as TemplateRef<any>)
      : null,
  );

  isTemplate(value: unknown): value is TemplateRef<any> {
    return value instanceof TemplateRef;
  }
}
